import { render, staticRenderFns } from "./FooterTwoButton.vue?vue&type=template&id=1763d04a&scoped=true"
import script from "./FooterTwoButton.vue?vue&type=script&lang=js"
export * from "./FooterTwoButton.vue?vue&type=script&lang=js"
import style0 from "./FooterTwoButton.vue?vue&type=style&index=0&id=1763d04a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1763d04a",
  null
  
)

export default component.exports